
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/power-design/service-tool.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-power-design-service-tool-demo-basic","docs-power-design-service-tool-demo-config","docs-power-design-service-tool-demo-style"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/power-design/service-tool.md?type=demo')
};